"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tutorial = void 0;
exports.tutorial = {
    isEnable: false,
    gameId: '',
    buttonImageUrl: 'https://dwfedcf5lscmq.cloudfront.net/skins/638621560234b.png',
    buttonStyle: {
        top: '1%',
        left: '1%',
    },
    tutorialImageUrl: 'https://dwfedcf5lscmq.cloudfront.net/skins/6386214d20396.png',
};
